export default __webpack_public_path__ + "static/media/page9.a5014ce2.webp";